// shared/src/schemas/macro-universe-extension.ts
// Zod schema for `macro_universe_extension` table (0002:62-71 + 0032).
// 8 columns. One row per analyst-added ticker (predictions on tickers outside
// CONTEXT_TICKERS trigger vendor-validated auto-add per design doc §Universe —
// dynamic extension fork resolution).
//
// RC-D (0032, 2026-05-29): added last_fetch_ok_at for the auto-extend
// lifecycle prune (stale = not predicted 30d; unfetchable = no successful
// daily-close fetch 30d).

import { z } from 'zod';

export const MacroUniverseExtensionVendorEnum = z.enum(['yahoo', 'polygon', 'crypto.com']);

export const MacroUniverseExtensionSchema = z.object({
  ticker:             z.string(),
  vendor:             MacroUniverseExtensionVendorEnum,
  asset_class:        z.string(),
  added_at:           z.string().datetime(),
  added_by_brief_id:  z.string(),
  fetch_failures_30d: z.number().int().nonnegative(),
  last_predicted_at:  z.string().datetime().nullable(),
  // RC-D (0032): timestamp of the last successful daily-close fetch; null until
  // the first successful fetch (or for pre-0032 rows). Drives the unfetchable
  // prune axis via COALESCE(last_fetch_ok_at, added_at).
  last_fetch_ok_at:   z.string().datetime().nullable(),
});

export type MacroUniverseExtension = z.infer<typeof MacroUniverseExtensionSchema>;
